import React from "react";
import { useLocation } from "react-router";
import BankFeedsCommonLayout, {
  OrgInfo,
} from "../../components/bankFeeds/layout";

const BankFeedsError: React.FC = () => {
  const location = useLocation<{ orgInfo: OrgInfo }>();
  const { orgInfo } = location.state || { orgInfo: {} as OrgInfo };

  return (
    <BankFeedsCommonLayout
      companyLogoUrl={orgInfo.companyLogoUrl}
      name={orgInfo.name}
    >
      <div className="mt-4 text-lg">
        There was a temporary issue connecting to your financial institution.
        Please restart the linking process.
      </div>
    </BankFeedsCommonLayout>
  );
};

export default BankFeedsError;
